module.exports = __webpack_public_path__ + "img/zn_action.3cdb7d30.png";